// ═══════════════════════════════════════════════
// Constants partagées — Elixir Prep
// ═══════════════════════════════════════════════

export const TOURNEE_ORDER = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, 'CHRONOPOST': 90, 'IMPERATIFS': 99 };

export const TOURNEE_COLORS = {
  '1': '#1A5276', '2': '#1E6B3C', '3': '#7D5A0A', '4': '#5B2C8D',
  '5': '#922B21', '6': '#117A65', 'CHRONOPOST': '#6B7280', 'IMPERATIFS': '#B03A2E',
};

export function tourneeLabel(t) {
  if (!t) return 'Sans tournée';
  if (t === 'IMPERATIFS') return 'Imp.';
  return 'T' + t;
}

export function tourneeSortKey(t) {
  return TOURNEE_ORDER[t] || (t ? 50 : 100);
}
